import { defineComponent as _defineComponent } from 'vue'
import { now } from '@/utils/datetime';
import { PropType, reactive, ref } from 'vue';

import { SdsSection9BoilingPoint } from '@/interfaces/model/general/sds';
import { NewSdsSection9BoilingPoint } from '@/lib/constructor/model/general/sds';
import { TEMPERATURE_MINIMUM, TEMPERATURE_MAXIMUM } from '@/lib/constant';

import SdsSection9BoilingPointForm from '@/views/dashboard/sdsDrawer/forms/SdsSection9BoilingPointForm.vue';
import { TemperatureUnitId } from '@/lib/enum';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsTableSection9BoilingPoint',
  props: {
  isEditing: {
    type: Boolean,
    default: false,
  },
  boilingPointList: {
    type: Array as PropType<Array<SdsSection9BoilingPoint>>,
    required: true,
    default: () => [],
  },
},
  emits: ["update:isValid", "update:boilingPointList"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:boilingPointList', data: Array<SdsSection9BoilingPoint>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  registerData: '沸点のデータを登録してください',
  boilingPoint: '沸点',
});


const headerSection9 = [
  { text: $t(m.boilingPoint), value: 'boilingPoint', sortable: false },
  {
    text: $t(sharedMessages.measurementMethod),
    value: 'boilingPointMeasurement',
    sortable: false,
  },
  { text: '', value: 'action', sortable: false },
];
const isValidNewBoilingPoint = ref<boolean>(false);
const isValidUpdatedBoilingPoint = ref<boolean>(false);
const expanded = ref<Array<number>>([0]);

const newBoilingPoint = reactive<SdsSection9BoilingPoint>(
  structuredClone(NewSdsSection9BoilingPoint)
);
const updatedBoilingPoint = reactive<SdsSection9BoilingPoint>(
  structuredClone(NewSdsSection9BoilingPoint)
);

const boilingPointIndex = ref<number>(0);

const modalNewBoilingPoint = ref<boolean>(false);
const modalDeleteBoilingPoint = ref<boolean>(false);
const modalRescueBoilingPoint = ref<boolean>(false);
const modalEditBoilingPoint = ref<boolean>(false);

const openNewBoilingPointModal = (): void => {
  modalNewBoilingPoint.value = true;
};

const closeNewBoilingPointModal = (): void => {
  modalNewBoilingPoint.value = false;
};

const openDeleteBoilingPointModal = (): void => {
  modalDeleteBoilingPoint.value = true;
};

const closeDeleteBoilingPointModal = (): void => {
  modalDeleteBoilingPoint.value = false;
};

const openRescueBoilingPointModal = (): void => {
  modalRescueBoilingPoint.value = true;
};

const closeRescueBoilingPointModal = (): void => {
  modalRescueBoilingPoint.value = false;
};

const openEditBoilingPointModal = (): void => {
  modalEditBoilingPoint.value = true;
};

const closeEditBoilingPointModal = (): void => {
  modalEditBoilingPoint.value = false;
};



const bindBoilingPoint = () => {
  updatedBoilingPoint.id = props.boilingPointList[boilingPointIndex.value].id;
  updatedBoilingPoint.sds_id =
    props.boilingPointList[boilingPointIndex.value].sds_id;
  updatedBoilingPoint.sds_product_id =
    props.boilingPointList[boilingPointIndex.value].sds_product_id;
  updatedBoilingPoint.boiling_point_min =
    props.boilingPointList[boilingPointIndex.value].boiling_point_min;
  updatedBoilingPoint.boiling_point_max =
    props.boilingPointList[boilingPointIndex.value].boiling_point_max;
  updatedBoilingPoint.boiling_point_inequality_sign =
    props.boilingPointList[
      boilingPointIndex.value
    ].boiling_point_inequality_sign;
  updatedBoilingPoint.unit_id =
    props.boilingPointList[boilingPointIndex.value].unit_id;
  updatedBoilingPoint.measurement_method =
    props.boilingPointList[boilingPointIndex.value].measurement_method;
};

const clearNewForm = () => {
  newBoilingPoint.boiling_point_inequality_sign = 1;
  newBoilingPoint.boiling_point_min = 0;
  newBoilingPoint.boiling_point_max = 0;
  newBoilingPoint.unit_id = '℃';
  newBoilingPoint.measurement_method = '';
};

const addBoilingPoint = () => {
  switch (newBoilingPoint.boiling_point_inequality_sign) {
    case 0:
      newBoilingPoint.boiling_point_min = TEMPERATURE_MINIMUM;
      newBoilingPoint.boiling_point_max = TEMPERATURE_MAXIMUM;
      break;
    case 1:
      newBoilingPoint.boiling_point_max = newBoilingPoint.boiling_point_min;
      break;
    case 2:
      newBoilingPoint.boiling_point_max = TEMPERATURE_MAXIMUM;
      break;
    case 3:
      newBoilingPoint.boiling_point_max = TEMPERATURE_MAXIMUM;
      break;
    case 4:
      newBoilingPoint.boiling_point_min = TEMPERATURE_MINIMUM;
      break;
    case 5:
      newBoilingPoint.boiling_point_min = TEMPERATURE_MINIMUM;
      break;
    case 6:
      break;
    case 7:
      break;
    case 8:
      break;
    case 9:
      break;
    default:
      break;
  }
  const data: Array<SdsSection9BoilingPoint> = [...props.boilingPointList];
  data.push(structuredClone(newBoilingPoint));

  emits('update:boilingPointList', data);
};

const editBoilingPoint = () => {
  switch (updatedBoilingPoint.boiling_point_inequality_sign) {
    case 1:
      updatedBoilingPoint.boiling_point_max =
        updatedBoilingPoint.boiling_point_min;
      break;
    case 2:
      updatedBoilingPoint.boiling_point_max = TEMPERATURE_MAXIMUM;
      break;
    case 3:
      updatedBoilingPoint.boiling_point_max = TEMPERATURE_MAXIMUM;
      break;
    case 4:
      updatedBoilingPoint.boiling_point_min = TEMPERATURE_MINIMUM;
      break;
    case 5:
      updatedBoilingPoint.boiling_point_min = TEMPERATURE_MINIMUM;
      break;
    case 6:
      break;
    case 7:
      break;
    case 8:
      break;
    case 9:
      break;
    default:
      break;
  }
  const data: Array<SdsSection9BoilingPoint> = [...props.boilingPointList];
  data[boilingPointIndex.value] = structuredClone(updatedBoilingPoint);

  emits('update:boilingPointList', data);
};

const deleteBoilingPoint = (): void => {
  const data: Array<SdsSection9BoilingPoint> = [...props.boilingPointList];
  data[boilingPointIndex.value].deleted_at = now().toString();

  emits('update:boilingPointList', data);
};

const rescueBoilingPoint = (): void => {
  const data: Array<SdsSection9BoilingPoint> = [...props.boilingPointList];
  data[boilingPointIndex.value].deleted_at = null;

  emits('update:boilingPointList', data);
};

const parseBoilingPoint = (bp: SdsSection9BoilingPoint): string => {
  let parsedBoilingPoint = '';
  const unit = TemperatureUnitId.fromId(bp.unit_id).text;

  switch (bp.boiling_point_inequality_sign) {
    case 1:
      parsedBoilingPoint = $t(sharedMessages.valuesEqual, {
        value: bp.boiling_point_min,
        unit,
      });
      break;
    case 2:
      parsedBoilingPoint = $t(sharedMessages.valuesGreaterThanOrEqual, {
        value: bp.boiling_point_min,
        unit,
      });
      break;
    case 3:
      parsedBoilingPoint = $t(sharedMessages.valuesGreaterThan, {
        value: bp.boiling_point_min,
        unit,
      });
      break;
    case 4:
      parsedBoilingPoint = $t(sharedMessages.valuesLessThanOrEqual, {
        value: bp.boiling_point_max,
        unit,
      });
      break;
    case 5:
      parsedBoilingPoint = $t(sharedMessages.valuesLessThan, {
        value: bp.boiling_point_max,
        unit,
      });
      break;
    case 6:
      parsedBoilingPoint = $t(sharedMessages.valuesBetweenInclusive, {
        minValue: bp.boiling_point_min,
        maxValue: bp.boiling_point_max,
        unit,
      });
      break;
    case 7:
      parsedBoilingPoint = $t(sharedMessages.valuesBetweenExclusiveInclusive, {
        minValue: bp.boiling_point_min,
        maxValue: bp.boiling_point_max,
        unit,
      });
      break;
    case 8:
      parsedBoilingPoint = $t(sharedMessages.valuesBetweenExclusive, {
        minValue: bp.boiling_point_min,
        maxValue: bp.boiling_point_max,
        unit,
      });
      break;
    case 9:
      parsedBoilingPoint = $t(sharedMessages.valuesBetweenExclusiveExclusive, {
        minValue: bp.boiling_point_min,
        maxValue: bp.boiling_point_max,
        unit,
      });
      break;
    default:
      break;
  }

  return parsedBoilingPoint;
};

return { __sfc: true,$t, m, props, headerSection9, isValidNewBoilingPoint, isValidUpdatedBoilingPoint, expanded, newBoilingPoint, updatedBoilingPoint, boilingPointIndex, modalNewBoilingPoint, modalDeleteBoilingPoint, modalRescueBoilingPoint, modalEditBoilingPoint, openNewBoilingPointModal, closeNewBoilingPointModal, openDeleteBoilingPointModal, closeDeleteBoilingPointModal, openRescueBoilingPointModal, closeRescueBoilingPointModal, openEditBoilingPointModal, closeEditBoilingPointModal, emits, bindBoilingPoint, clearNewForm, addBoilingPoint, editBoilingPoint, deleteBoilingPoint, rescueBoilingPoint, parseBoilingPoint, SdsSection9BoilingPointForm, sharedMessages }
}

})